{
	"translateEventStatus": {
		"canceled": "Cancelado",
		"created": "Creado",
		"finished": "Completado",
		"running": "En proceso"
	},
	"translatePaymentMethod": {
		"anticipated": "Anticipado",
		"app": "App",
		"appPrePayment": "Pago via APP",
		"bonus": "Bono",
		"cash": "Efectivo",
		"creditCard": "Tarjeta de crédito",
		"dashboard": "Panel",
		"debitCard": "Tarjeta de débito",
		"pix": "Pix",
		"postEvent": "Post evento",
		"rappi": "Rappi",
		"voucher": "Voucher",
		"zigPosCredit": "Zig post crédito",
		"zigPosDebit": "Zig post débito",
		"integratedFoodVoucher": "Vale de Alimentación"
	}
}
